module.exports = __webpack_public_path__ + "dde7271be6af89608e25ab3197f5c433.jpg";